import { PartnerFile } from './partner-file.model';

export type PartnerType =
  | 'Asesoría, Gestoría o Despacho'
  | 'Empresa Local de Informática'
  | 'Canal de Partner Wolters Kluwer'
  | 'Canal de Partner Odoo'
  | 'Fabricante de Software'
  | 'Agencia de Marketing o Web'
  | 'Convenios y Asociaciones'
  | 'Consultor o Freelance';

export const PARTNER_TYPE_OPTIONS: { label: string; value: PartnerType }[] = [
  { label: 'Asesoría, Gestoría o Despacho', value: 'Asesoría, Gestoría o Despacho' },
  { label: 'Empresa Local de Informática', value: 'Empresa Local de Informática' },
  { label: 'Canal de Partner Wolters Kluwer', value: 'Canal de Partner Wolters Kluwer' },
  { label: 'Canal de Partner Odoo', value: 'Canal de Partner Odoo' },
  { label: 'Fabricante de Software', value: 'Fabricante de Software' },
  { label: 'Agencia de Marketing o Web', value: 'Agencia de Marketing o Web' },
  { label: 'Convenios y Asociaciones', value: 'Convenios y Asociaciones' },
  { label: 'Consultor o Freelance', value: 'Consultor o Freelance' },
];

export type SettlementPeriodicity = 'Mensual' | 'Trimestral' | 'Anual';

export const SETTLEMENT_PERIODICITY_OPTIONS: { label: string; value: SettlementPeriodicity }[] = [
  { label: 'Mensual', value: 'Mensual' },
  { label: 'Trimestral', value: 'Trimestral' },
  { label: 'Anual', value: 'Anual' },
];

export type DistributionModality =
  | 'Reventa'
  | 'Distribución Comercial'
  | 'Modelo Mixto'
  | 'Distribución Integral';

export const DISTRIBUTION_MODALITY_OPTIONS: { label: string; value: DistributionModality }[] = [
  { label: 'Reventa', value: 'Reventa' },
  { label: 'Distribución Comercial', value: 'Distribución Comercial' },
  { label: 'Modelo Mixto', value: 'Modelo Mixto' },
  { label: 'Distribución Integral', value: 'Distribución Integral' },
];

export interface PartnerContract {
  number: number;
  status: 'pending' | 'signed';
  signed_at: string | null;
  renewal_date: string | null;
  document_name: string | null;
}

export interface Partner {
  id: string;
  company_id: string;
  company_name: string;
  company_phone?: string;
  company_email?: string;
  company_createdate: string;
  status: 'active' | 'inactive' | 'archived';
  company_address?: string;
  company_iban?: string;
  cif?: string;
  fixed_commission?: number;
  recurring_commission?: number;
  type?: PartnerType;
  comments?: string;
  relationship_type?: string;
  distribution_modality?: DistributionModality;
  operation_limit?: number;
  settlement_periodicity?: SettlementPeriodicity;
  min_new_clients_per_year?: number;
  referrers?: string[]; // Campo para almacenar los referidos del partner
  users_count?: number;
  opportunities_count?: number;
  billing?: number;
  pipeline?: number;
  last_login_at?: string;
  files?: PartnerFile[];
  contract?: PartnerContract | null;
  contract_status?: 'pending' | 'signed' | null;
  created_at: string;
  updated_at: string;
}
